import { createRoot } from 'react-dom/client';
import App from './App';
import './index.scss';
import '../src/styles/_common.scss';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
//import { msalConfig } from './authConfig.development.js';
import { BrowserRouter } from 'react-router-dom';

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */

let authConfig:any;

if (process.env.NODE_ENV === "production") {
    authConfig = require("./authConfig.production");
} 
else { // Default to development
    authConfig = require("./authConfig.local");
}

const pca = new PublicClientApplication(authConfig.msalConfig);

const root = createRoot(document.getElementById('root') as HTMLElement);

const themes = {
    dark: `${process.env.PUBLIC_URL}/smartlocator.css`,
    light: `${process.env.PUBLIC_URL}/light-theme.css`,
};


root.render(
    // <React.StrictMode>
         <BrowserRouter future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true,
          }}>
            <MsalProvider instance={pca}>
                <App />
            </MsalProvider>
        </BrowserRouter>
    // </React.StrictMode>
);
